import React, { Component, useState } from 'react';
// import { Link } from 'react-router-dom';
import useOpenAI from '../hooks/useOpenAi';

import 'react-perfect-scrollbar/dist/css/styles.css';
import { useEffect } from 'react';

export default function SideBox() {


    const { imageURLs, loading, generateImage } = useOpenAI();
    const [savedUrls, setSavedUrls] = useState([]);

    const handleGenerateImage = (e) => {
        e.preventDefault();
        setSavedUrls([])
        // Generate the image using OpenAI
        const key1 = e.target.prompt1.value;
        const key2 = e.target.prompt2.value;
        const description = e.target.description.value;
        const finalPrompt = `${key1}, ${key2}, more details: ${description}`;
        generateImage(finalPrompt);
        e.target.prompt1.value = "";
        e.target.prompt2.value = "";
        e.target.description.value = " ";

    };

    useEffect(() => {
        // Save the image URLs to local storage
        localStorage.setItem('imageURLs', JSON.stringify(imageURLs));
        setSavedUrls(imageURLs);
    }, [imageURLs]);

    useEffect(() => {
        // Retrieve the image URLs from local storage
        const imageUrls = localStorage.getItem('imageURLs');
        if (imageUrls) {
            setSavedUrls(JSON.parse(imageUrls));
        }
    }, []);

    return (
        <>
            <div class="about-sidebox" >
                <a href="javascript:void(0)" class="closebtn bg-primary">×</a>
                <div class="about-section">
                    <div class="gallery-area content scroll-off" style={{ "backgroundImage": "url(images/background/bg1.jpg)" }}>
                        <div class="row lightgallery" id="lightgallery">

                            {/* {savedUrls[0] != null && <div className="col-md-6 col-6 card-container wow flipInX" data-wow-duration="0.80s" data-wow-delay="0.5s" >
                                <div className="gallery-box">
                                    <div className="gallery-media check-km" data-exthumbimage={savedUrls[0]}
                                        data-src={savedUrls[0]} title={`Generated Image ${0}`}>
                                        <img src={savedUrls[0]} alt={`Generated Image ${0}`}  />
                                    </div>
                                </div>
                            </div>}
                            {savedUrls[1] != null && <div className="col-md-6 col-6 card-container " >
                                <div className="gallery-box">
                                    <div className="gallery-media check-km" data-exthumbimage={savedUrls[1]}
                                        data-src={savedUrls[1]} title={`Generated Image ${1}`}>
                                        <img src={savedUrls[1]} alt={`Generated Image ${1}`} />
                                    </div>
                                </div>
                            </div>}
                            {savedUrls[2] != null && <div className="col-md-6 col-6 card-container " >
                                <div className="gallery-box">
                                    <div className="gallery-media check-km" data-exthumbimage={savedUrls[2]}
                                        data-src={savedUrls[0]} title={`Generated Image ${2}`}>
                                        <img src={savedUrls[2]} alt={`Generated Image ${2}`} />
                                    </div>
                                </div>
                            </div>}
                            {savedUrls[3] != null && <div className="col-md-6 col-6 card-container  " >
                                <div className="gallery-box">
                                    <div className="gallery-media check-km" data-exthumbimage={savedUrls[3]}
                                        data-src={savedUrls[3]} title={`Generated Image ${3}`}>
                                        <img src={savedUrls[3]} alt={`Generated Image ${3}`} />
                                    </div>
                                </div>
                            </div>} */}
                            {savedUrls && savedUrls.length > 0 ?
                                (
                                    <>
                                        {savedUrls.map((url, index) => (

                                            <div className="col-md-6 col-6 card-container wow flipInX" key={index}>
                                                <div className="gallery-box">
                                                    <div className="gallery-media check-km" data-exthumbimage={url}
                                                        data-src={url} title={`Generated Image ${index}`}>
                                                        <img src={url} alt={`Generated Image ${index}`} />
                                                    </div>
                                                </div>
                                            </div>

                                        ))}
                                    </>

                                ) : (
                                    !loading &&
                                    <>
                                        <div class="col-md-6 col-6 card-container wow flipInX" data-wow-duration="0.80s"
                                            data-wow-delay="0.5s">
                                            <div class="gallery-box">
                                                <div class="gallery-media check-km" data-exthumbimage="images/gallery/pic1.jpg"
                                                    data-src="images/gallery/main-pic1.jpg" title="Title Come Here">
                                                    <img src="images/gallery/pic1.jpg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-6 card-container">
                                            <div class="gallery-box">
                                                <div class="gallery-media check-km" data-exthumbimage="images/gallery/pic2.jpg"
                                                    data-src="images/gallery/main-pic2.jpg" title="Title Come Here">
                                                    <img src="images/gallery/pic2.jpg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-6 card-container">
                                            <div class="gallery-box">
                                                <div class="gallery-media check-km" data-exthumbimage="images/gallery/pic3.jpg"
                                                    data-src="images/gallery/main-pic3.jpg" title="Title Come Here">
                                                    <img src="images/gallery/pic3.jpg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-6 card-container">
                                            <div class="gallery-box">
                                                <div class="gallery-media check-km" data-exthumbimage="images/gallery/pic4.jpg"
                                                    data-src="images/gallery/main-pic4.jpg" title="Title Come Here">
                                                    <img src="images/gallery/pic4.jpg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-6 card-container">
                                            <div class="gallery-box">
                                                <div class="gallery-media check-km" data-exthumbimage="images/gallery/pic5.jpg"
                                                    data-src="images/gallery/main-pic5.jpg" title="Title Come Here">
                                                    <img src="images/gallery/pic5.jpg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-6 card-container">
                                            <div class="gallery-box">
                                                <div class="gallery-media check-km" data-exthumbimage="images/gallery/pic6.jpg"
                                                    data-src="images/gallery/main-pic6.jpg" title="Title Come Here">
                                                    <img src="images/gallery/pic6.jpg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-6 card-container">
                                            <div class="gallery-box">
                                                <div class="gallery-media check-km" data-exthumbimage="images/gallery/pic7.jpg"
                                                    data-src="images/gallery/main-pic7.jpg" title="Title Come Here">
                                                    <img src="images/gallery/pic7.jpg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-6 card-container">
                                            <div class="gallery-box">
                                                <div class="gallery-media check-km" data-exthumbimage="images/gallery/pic8.jpg"
                                                    data-src="images/gallery/main-pic8.jpg" title="Title Come Here">
                                                    <img src="images/gallery/pic8.jpg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}


                            {loading && (


                                <div className="logo wow fadeInUp bottom-left  loader-black col-6 col-md-6" data-wow-duration="1.5s" data-wow-delay="1.0s">
                                    <a href="#"><img src="images/icon-black.png" alt="" className='rotated-image text-center' /></a>
                                </div>


                            )
                            }


                        </div>
                    </div>
                    {/* ================================================================== */}
                    <div class="contact-box pictures">
                        <div class="contact-form picture-form">
                            <h1 class="text-center">Create a Picutre</h1>
                            <br></br>
                            <form class="dzForm dezPlaceAni" onSubmit={handleGenerateImage} >
                                <h6 class="title">MassAi - Pictures</h6>

                                <div class="dzFormMsg"></div>
                                <input type="hidden" value="Contact" name="dzToDo" />
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label >Keyword 1</label>
                                            <input name="prompt1" type="text" required class="form-control " />
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Keyword 2</label>
                                            <input name="prompt2" type="text" class="form-control" required />
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <label>Picture Description</label>
                                            <textarea name="description" rows="4" class="form-control" required > </textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12 text-right">
                                        <button name="submit" type="submit" value="Submit"
                                            class="site-button gradient shadow radius-md button-lg black">Create Picture</button>
                                    </div>
                                </div>
                            </form>
                            {/* <div class="map-box">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d227748.3825624477!2d75.65046970649679!3d26.88544791796718!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396c4adf4c57e281%3A0xce1c63a0cf22e09!2sJaipur%2C+Rajasthan!5e0!3m2!1sen!2sin!4v1500819483219"
                                        class="align-self-stretch radius-sm" style={{ "border": "0" }} allowfullscreen></iframe>
                                </div>
                                <a href="#" class="site-button map-btn"><span>View Map</span><span>Close</span></a> */}
                        </div>
                        {/* <div class="contact-info">
                                <div class="col">
                                    <div>
                                        <h5 class="title">Location</h5>
                                        <p>8901 Marmora Road Chi Minh City, Vietnam</p>
                                    </div>
                                </div>
                                <div class="col">
                                    <div>
                                        <h5 class="title">Email</h5>
                                        <a href="#">info@example.com</a>
                                    </div>
                                </div>
                            </div> */}
                        {/* <div class="lg-outer  lg-start-zoom lg-use-css3 lg-css3 lg-slide lg-show-after-load lg-pull-caption-up lg-has-thumb lg-can-toggle lg-use-transition-for-zoom lg-visible lg-thumb-open lg-grab lg-hide-items">
                            <div class="lg" style="width:100%; height:100%">
                                <div class="lg-inner" style="transition-timing-function: ease; transition-duration: 600ms;">
                                    <div class="lg-item lg-loaded lg-current lg-complete lg-zoomable">
                                        <div class="lg-img-wrap" data-x="0" data-y="0" style="transform: translate3d(0px, 0px, 0px);">
                                            <img class="lg-object lg-image" src="images/gallery/main-pic1.jpg" data-scale="1" style="transform: scale3d(1, 1, 1);" />
                                        </div>
                                    </div>
                                    <div class="lg-item lg-loaded lg-complete lg-zoomable lg-next-slide">
                                        <div class="lg-img-wrap"><img class="lg-object lg-image" src="images/gallery/main-pic2.jpg" />
                                        </div>
                                    </div>
                                    <div class="lg-item">

                                    </div>
                                    <div class="lg-item">
                                    </div>
                                    <div class="lg-item">
                                    </div><div class="lg-item">
                                    </div><div class="lg-item">
                                    </div><div class="lg-item lg-prev-slide">
                                    </div></div><div class="lg-toolbar lg-group">
                                    <span class="lg-close lg-icon">
                                    </span>
                                    <a id="lg-download" target="_blank" download="" class="lg-download lg-icon" href="images/gallery/main-pic1.jpg"></a>
                                    <span class="lg-autoplay-button lg-icon"></span>
                                    <span class="lg-fullscreen lg-icon">
                                    </span><span id="lg-zoom-in" class="lg-icon">
                                    </span><span id="lg-zoom-out" class="lg-icon">
                                    </span><span id="lg-actual-size" class="lg-icon">
                                    </span><span id="lg-share" class="lg-icon">
                                        <ul class="lg-dropdown" style="position: absolute;">
                                            <li>
                                                <a id="lg-share-facebook" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Flocalhost%3A3001%2F%23lg%3D1%26slide%3D0"><span class="lg-icon">
                                                </span>
                                                    <span class="lg-dropdown-text">Facebook</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="lg-share-twitter" target="_blank" href="https://twitter.com/intent/tweet?text=undefined&amp;url=http%3A%2F%2Flocalhost%3A3001%2F%23lg%3D1%26slide%3D0"><span class="lg-icon"></span><span class="lg-dropdown-text">Twitter</span></a></li><li><a id="lg-share-googleplus" target="_blank" href="https://plus.google.com/share?url=http%3A%2F%2Flocalhost%3A3001%2F%23lg%3D1%26slide%3D0">
                                                    <span class="lg-icon"></span><span class="lg-dropdown-text">
                                                        GooglePlus</span>
                                                        </a></li>
                                                        <li>
                                                            <a id="lg-share-pinterest" target="_blank" href="http://www.pinterest.com/pin/create/button/?url=http%3A%2F%2Flocalhost%3A3001%2F%23lg%3D1%26slide%3D0&amp;media=images%2Fgallery%2Fmain-pic1.jpg&amp;description=undefined">
                                                                <span class="lg-icon">
                                                                    </span>
                                                                    <span class="lg-dropdown-text">Pinterest</span></a></li>
                                                                    </ul></span><div id="lg-counter"><span id="lg-counter-current">1</span> / <span id="lg-counter-all">8</span>
                                                                    </div></div><div class="lg-actions"><button class="lg-prev lg-icon"></button><button class="lg-next lg-icon">
                                                                        </button></div><div class="lg-sub-html">Title Come Here</div><div class="lg-progress-bar">
                                                                            <div class="lg-progress"></div></div><div class="lg-thumb-outer lg-grab" style="height: 100px;">
                                                                                <div class="lg-thumb lg-group" style="width: 840px; position: relative; transform: translate3d(0px, 0px, 0px); transition-duration: 600ms;">
                                                                                    <div data-vimeo-id="" class="lg-thumb-item active" style="width:100px; height: 100%; margin-right: 5px">
                                                                                        <img src="images/gallery/pic1.jpg" />
                                                                                        </div>
                                                                                        <div data-vimeo-id="" class="lg-thumb-item" style="width:100px; height: 100%; margin-right: 5px">
                                                                                            <img src="images/gallery/pic2.jpg" />
                                                                                            </div>
                                                                                            <div data-vimeo-id="" class="lg-thumb-item" style="width:100px; height: 100%; margin-right: 5px">
                                                                                                <img src="images/gallery/pic3.jpg" />
                                                                                                </div>
                                                                                                <div data-vimeo-id="" class="lg-thumb-item" style="width:100px; height: 100%; margin-right: 5px">
                                                                                                    <img src="images/gallery/pic4.jpg" />
                                                                                                    </div>
                                                                                                    <div data-vimeo-id="" class="lg-thumb-item" style="width:100px; height: 100%; margin-right: 5px">
                                                                                                        <img src="images/gallery/pic5.jpg" />
                                                                                                        </div>
                                                                                                        <div data-vimeo-id="" class="lg-thumb-item" style="width:100px; height: 100%; margin-right: 5px">
                                                                                                            <img src="images/gallery/pic6.jpg" />
                                                                                                            </div><div data-vimeo-id="" class="lg-thumb-item" style="width:100px; height: 100%; margin-right: 5px"><img src="images/gallery/pic7.jpg"></div><div data-vimeo-id="" class="lg-thumb-item" style="width:100px; height: 100%; margin-right: 5px"><img src="images/gallery/pic8.jpg" />
                                                        </div>
                                                        </div>
                                                        <span class="lg-toogle-thumb lg-icon">
                                                            </span>
                                                            </div>
                                                            <div id="lg-dropdown-overlay">
                                                                </div>
                                                                </div>
                                                                </div> */}
                    </div>
                </div>
            </div>

        </>
    );
}

